import React from "react"
import { Drawer, Icon, Avatar, Menu, Dropdown, Badge } from 'antd';
import { HashLink as Link } from 'react-router-hash-link';
import {  formatFriendlyDate } from "../config/Helpers";
import { latest as API_URL, login as API_LOGIN, lastest_insecure as API_URL_INSECURE } from "../config/api";
import axios from "axios";

const postUrlWidgets = API_URL + "news";

class News extends React.Component{
    constructor(props){
    super(props);
    this.state = {
        visible : true,
        notifications : {}
    };
    }

   
    handleLogout(event) {
        localStorage.removeItem("api_token");
        localStorage.removeItem("name");
        localStorage.removeItem("email");
        window.location.reload();
        this.props.setSession(false)
    }
    deleteNotification(id_delete){
        let qs = require("qs"), self = this;
        axios({
            method : "POST",
            headers: { 'content-type' : 'application/x-www-form-urlencoded' },
            url : postUrlWidgets + "/delete", 
            data : qs.stringify({ 
                api_token : localStorage.getItem('api_token'),
                id_delete : id_delete
            })
            
        }).then(function (response) {
            self.setState({
                notifications : response.data
            });
        });
    }
    componentWillReceiveProps(){
        if(this.props.app.state.news_window === false){
            return;
        }
        let qs = require("qs"), self = this;
        axios({
            method : "POST",
            headers: { 'content-type' : 'application/x-www-form-urlencoded' },
            url : postUrlWidgets + "/list", 
            data : qs.stringify({ 
                api_token : localStorage.getItem('api_token')
            })
            
        }).then(function (response) {
            self.setState({
                notifications : response.data
            });
        });
    }
    render(){
        let self = this
        const notifications_list = Object.keys(self.state.notifications).map(function(index){
            return (
                <li className="item">
                    <ul>
                        <li className="header regular">
                            {self.state.notifications[index].title}
                            <i 
                                className="fa fa-times-circle remove clickable" 
                                onClick={self.deleteNotification.bind(self, self.state.notifications[index]._id)}
                            />
                        </li>
                        <li className="details">    
                            <div className="message">
                                <p>{self.state.notifications[index].msg}</p>
                            </div>
                            <div className="datetime">
                                <i className="clock"></i>
                                <span className="days">{formatFriendlyDate(self.state.notifications[index].created_at)}</span>
                                <span className="time">{self.state.notifications[index].created_at}</span>
                            </div>
                            
                        </li>
            
                    </ul>
                </li>
            )
        })
        return(
            <Drawer
                title={'NEWS'}
                placement={this.state.placement}
                closable={true}
                onClose={() => {
                    this.props.app.setState({
                        news_window : false
                    })
                }}
                visible={this.props.app.state.news_window}
                width={320}
                className="sidebar-notify"
                >
                {
                    (notifications_list.length > 0) ? 
                        <ul className='list'>
                            {notifications_list}
                        </ul> : 
                        <span style={{
                            lineHeight : '30px',
                            width : '260px',
                            display : 'inline-block',
                            position : 'absolute',
                            right : '50%',
                            marginRight : '-130px',
                            top : '50%',
                            marginTop : '-15px',
                            textAlign : 'center',
                            fontSize: '20px',
                            color: '#CCC',
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            letterSpacing: '1px'
                        }} children="NEWS NOT FOUND" />
                }
            </Drawer>
        )
    }
};

export default News


// WEBPACK FOOTER //
// ./src/Frontend/components/News.js